import { render, staticRenderFns } from "./longOrderList.vue?vue&type=template&id=822463c4&scoped=true&"
import script from "./longOrderList.js?vue&type=script&lang=js&"
export * from "./longOrderList.js?vue&type=script&lang=js&"
import style0 from "./longOrderList.vue?vue&type=style&index=0&id=822463c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822463c4",
  null
  
)

export default component.exports